import React, { useCallback, useEffect, useState } from 'react';
import ProjectsInfo from '../components/ProjectsInfo';
import dashboardCircle from '@assets/icons/dashboard-circle.png';
import WastageProjectInfoMonthly from '../components/WastageProjectInfoMonthly';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBUList_TA,
  getLeaderShipToolAnalytics,
  getLeadershipToolData,
  getProjectList_TA,
  getSBGList_TA,
  getSBUList_TA,
} from '../redux/slice';
import {
  getListOfCurrentYearMonths,
  getListOfSelectedYearMonths,
  getPreviousMonth,
  getYears,
} from '@utils/helpers';
import { debounce } from 'lodash';
import { Button, Row, Select, Tooltip } from 'antd';
import * as XLSX from 'xlsx';
import AdvanceFilter from '../components/AdvanceFilter';
import DashboardFilterSelectorsMonthly from '../components/DashboardFilterSelectorsMonthly';
import viewerBgImg from '@assets/images/dsahboard_bg.png';
import backlogIcon from '@assets/icons/backlog.svg';
import ironBarIcon from '@assets/icons/iron_bar.svg';
import valueChainIcon from '@assets/icons/value_chain.svg';
import recycleBinIcon from '@assets/icons/recycle_bin.svg';
import checkIcon from '@assets/icons/check.svg';
import garbageIcon from '@assets/icons/garbage.svg';
import coinsIcon from '@assets/icons/coins.svg';
import warningIcon from '@assets/icons/warning.svg';
import MetricsCard from '../components/MetricsCard';

// finding last month
const LAST_MONTH = getPreviousMonth();
// const CURR_MONTH = getCurrentMonth();
const YEARS = getYears();

const ToolAdherence = () => {
  const dispatch = useDispatch();
  const {
    leaderShipToolAnalytics,
    leaderShipToolAnalyticsLoading,
    leadershipToolData,
    leadershipToolDataLoading,
    sbgListData,
    sbgListLoading,
    sbuListData,
    sbuListLoading,
    buListData,
    buListLoading,
    projectListData,
    projectListLoading,
  } = useSelector((state) => state.viewer);
  const [selectedFilters, setSelectedFilters] = useState([]);

  // const [open, setOpen] = useState(false);
  // const showDrawer = () => {
  //   setOpen(true);
  // };

  // const onClose = () => {
  //   setOpen(false);
  // };

  // const handleFilter = (filterData) => {
  //   const payload = {
  //     month_array: JSON.stringify(
  //       filterData.flatMap((month) => getPreviousMonths(month.complete)),
  //     ),
  //   };
  //   setSelectedFilters(filterData.map((month) => month.title));
  //   dispatch(getLeaderShipToolAnalytics(payload));
  //   dispatch(getLeadershipToolData(payload));
  //   onClose();
  // };

  // useEffect(() => {
  //   const payload = {
  //     month_array: JSON.stringify(
  //       getPreviousMonths(FINANCIAL_MONTHS.at(-2).complete),
  //     ),
  //   };
  //   dispatch(getLeaderShipToolAnalytics(payload));
  //   dispatch(getLeadershipToolData(payload));
  // }, [dispatch]);

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [selectedSBG, setSelectedSBG] = useState([]);
  const [selectedSBU, setSelectedSBU] = useState([]);
  const [selectedBU, setSelectedBU] = useState([]);
  const [selectedProjectsCode, setSelectedProjectsCode] = useState([]);
  const [selectedProjectsName, setSelectedProjectsName] = useState([]);
  const [loadProjectNames, setLoadProjectNames] = useState([]);
  const [isInitialDataFetch, setIsInitialDataFetch] = useState(true);
  const [FINANCIAL_MONTHS, setFINANCIAL_MONTHS] = useState([]);

  // const FINANCIAL_MONTHS = getListOfCurrentYearMonths();

  const getTransformedFinancialQuarters = useCallback(() => {
    const months = selectedMonths?.length ? selectedMonths : [LAST_MONTH];
    // const allMonths = months
    //   .filter((v) => v !== 'all')
    //   .flatMap((month) => getPreviousMonths(month));

    // return transformMonthsToFinancialQuarters(allMonths);
    return months.filter((m) => m !== 'all');
  }, [selectedMonths]);

  const handleApplyFilter = () => {
    const payload = {};

    if (selectedMonths.filter((v) => v !== 'all').length) {
      payload.filter_array = JSON.stringify(getTransformedFinancialQuarters());
    }

    if (selectedSBG.filter((v) => v !== 'all').length) {
      payload.sbg = selectedSBG.filter((v) => v !== 'all').join(', ');
    }

    if (selectedSBU.filter((v) => v !== 'all').length) {
      payload.sbu = selectedSBU.filter((v) => v !== 'all').join(', ');
    }
    if (selectedBU.filter((v) => v !== 'all').length) {
      payload.bu = selectedBU.filter((v) => v !== 'all').join(', ');
    }

    if (!selectedProjectsName.length) {
      if (selectedProjectsCode.filter((v) => v !== 'all').length) {
        payload.project_code = [...new Set([...selectedProjectsCode])]
          .filter((v) => v !== 'all')
          .join(', ');
      }
    } else {
      if (selectedProjectsName.filter((v) => v !== 'all').length) {
        payload.project_code = [...new Set([...selectedProjectsName])]
          .filter((v) => v !== 'all')
          .join(', ');
      }
    }
    if (!selectedMonths.length) {
      payload.filter_array = JSON.stringify(getTransformedFinancialQuarters());
    }

    dispatch(getLeaderShipToolAnalytics(payload));
    dispatch(getLeadershipToolData(payload));
    setIsInitialDataFetch(false);
  };

  const restMappedData = (item) => {
    return {
      'Project Value': item.project_value || null,
      POCM: item.pocm,
      'Quantity Processed - Quarterly': item.quantity_processed,
      'Wastage Percentage': Number(item.wastage_percentage).toFixed(2),
      'Budgeted Wastage': item.budgeted_wastage,
      'Savings/Overruns Wastage (in %)': Number(item.savings_per).toFixed(2),
      'Savings/Overruns Wastage (In Ton)': Number(item.savings_in_ton).toFixed(
        2,
      ),
      'Savings/Overruns Wastage (In Lakh)': item.savings_in_lakh,
    };
  };

  const getTransformedProjectsData = (data = []) => {
    let flattenedData = [];

    data.forEach((item) => {
      const currentSBG = item.name;

      // Add top-level SBG row only once
      flattenedData.push({
        SBG: currentSBG,
        SBU: '',
        BU: '',
        'Project Code': '',
        BBS: '',
        ...restMappedData(item),
      });

      if (item.SBU) {
        item.SBU.forEach((sbuItem) => {
          flattenedData.push({
            SBG: currentSBG,
            SBU: sbuItem.name,
            BU: '',
            'Project Code': '',
            BBS: '',
            ...restMappedData(sbuItem),
          });

          if (sbuItem.BU) {
            sbuItem.BU.forEach((buItem) => {
              flattenedData.push({
                SBG: currentSBG,
                SBU: sbuItem.name,
                BU: buItem.name,
                'Project Code': '',
                BBS: '',
                ...restMappedData(buItem),
              });

              if (buItem.projects) {
                buItem.projects.forEach((project) => {
                  flattenedData.push({
                    SBG: currentSBG,
                    SBU: sbuItem.name,
                    BU: buItem.name,
                    'Project Code': project.code,
                    BBS: '',
                    ...restMappedData(project),
                  });

                  if (project.BBS) {
                    project.BBS.forEach((bbs) => {
                      flattenedData.push({
                        SBG: currentSBG,
                        SBU: sbuItem.name,
                        BU: buItem.name,
                        'Project Code': project.code,
                        BBS: bbs.bbs_id,
                        ...restMappedData(bbs),
                      });
                    });
                  }
                });
              }
            });
          }
        });
      }
    });

    return flattenedData;
  };

  const handleDownloadExcelSheet = () => {
    if (!leadershipToolData || leadershipToolData.length === 0) {
      alert('No data available to download.');
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(
      getTransformedProjectsData(leadershipToolData),
    );
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Wastage Information');
    XLSX.writeFile(workbook, `Wastage Information.xlsx`);
  };

  const getAllInitialData = useCallback(() => {
    setSelectedYear(null);
    setSelectedMonths(isInitialDataFetch ? [] : [LAST_MONTH]);

    dispatch(getSBGList_TA()).then((res) => setSelectedSBG([]));
    dispatch(getSBUList_TA()).then((res) => setSelectedSBU([]));
    dispatch(getBUList_TA()).then((res) => setSelectedBU([]));
    dispatch(getProjectList_TA()).then((res) => {
      setSelectedProjectsName([]);
      setSelectedProjectsCode([]);
    });

    // const payload = {
    //   filter_array: JSON.stringify(
    //     transformMonthsToFinancialQuarters([LAST_MONTH]),
    //   ),
    // };
    const payload = {
      filter_array: JSON.stringify(getTransformedFinancialQuarters()),
    };
    dispatch(getLeaderShipToolAnalytics(payload));
    dispatch(getLeadershipToolData(payload));
    setIsInitialDataFetch(true);
  }, [dispatch]);

  useEffect(() => {
    getAllInitialData();
  }, [getAllInitialData]);

  // ...... on year change fetching all list apis
  useEffect(() => {
    if (selectedYear) {
      const FINANCIAL_MONTHS = getListOfSelectedYearMonths(selectedYear);
      setFINANCIAL_MONTHS(FINANCIAL_MONTHS);
      setSelectedMonths([]);
      setSelectedSBG([]);
      setSelectedSBU([]);
      setSelectedBU([]);
      setSelectedProjectsCode([]);
      setSelectedProjectsName([]);
    }
  }, [selectedYear, dispatch]);

  // ...... on months change fetching all list apis
  useEffect(() => {
    if (selectedMonths.filter((v) => v !== 'all').length) {
      const payload = {
        filter_array: JSON.stringify(getTransformedFinancialQuarters()),
      };
      dispatch(getSBGList_TA(payload));
      dispatch(getProjectList_TA(payload));
      dispatch(getSBUList_TA(payload));
      dispatch(getBUList_TA(payload));
      setSelectedSBG([]);
      setSelectedSBU([]);
      setSelectedBU([]);
      setSelectedProjectsCode([]);
      setSelectedProjectsName([]);
    }
  }, [selectedMonths, dispatch]);

  useEffect(() => {
    if (selectedSBG.filter((v) => v !== 'all').length) {
      const payload = {
        filter_array: JSON.stringify(getTransformedFinancialQuarters()),
        sbg_array: JSON.stringify(selectedSBG),
      };
      dispatch(getSBUList_TA(payload));
      dispatch(getBUList_TA(payload));
      dispatch(getProjectList_TA(payload));
      setSelectedSBU([]);
      setSelectedBU([]);
      setSelectedProjectsCode([]);
      setSelectedProjectsName([]);
    }
  }, [selectedSBG, dispatch]);

  useEffect(() => {
    if (
      // selectedSBG.filter((v) => v !== 'all').length &&
      selectedSBU.filter((v) => v !== 'all').length
    ) {
      const payload = {
        filter_array: JSON.stringify(getTransformedFinancialQuarters()),
        sbg_array: JSON.stringify(selectedSBG),
        sbu_array: JSON.stringify(selectedSBU),
      };
      dispatch(getBUList_TA(payload));
      dispatch(getProjectList_TA(payload));
      setSelectedBU([]);
      setSelectedProjectsCode([]);
      setSelectedProjectsName([]);
    }
  }, [dispatch, selectedSBU]);

  useEffect(() => {
    if (
      // selectedSBG.filter((v) => v !== 'all').length &&
      // selectedSBU.filter((v) => v !== 'all').length &&
      selectedBU.filter((v) => v !== 'all').length
    ) {
      const payload = {
        filter_array: JSON.stringify(getTransformedFinancialQuarters()),
        sbg_array: JSON.stringify(selectedSBG),
        sbu_array: JSON.stringify(selectedSBU),
        bu_array: JSON.stringify(selectedBU),
      };
      dispatch(getProjectList_TA(payload));
      setSelectedProjectsCode([]);
      setSelectedProjectsName([]);
    }
  }, [dispatch, selectedBU]);

  useEffect(() => {
    if (selectedProjectsCode.filter((v) => v !== 'all').length) {
      setLoadProjectNames(
        projectListData.filter((p) =>
          selectedProjectsCode.includes(p.project_code),
        ),
      );
      setSelectedProjectsName([]);
    }
  }, [selectedProjectsCode, projectListData]);

  const COUNTS = [
    {
      counts: leaderShipToolAnalytics?.total_approved_projects || 0,
      countsSubLabel: 'Total Projects',
      label: 'in bbs optimization tool',
      countColor: '#1C4E9D',
      icon: backlogIcon,
      bigText: true,
      bgColor: '#b1cffe',
      hasOuterLayer: true,
      outerLayerBg: '#FFFFFF',
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#ffffff',
      iconClasses: 'h-[105px] -right-3.5 -top-4 w-28',
      onHoverContent: null,
    },
    {
      counts: Number(
        leaderShipToolAnalytics?.total_quantity_processed || 0,
      ).toFixed(2),
      label: 'With/without bbs Optimization tool',
      subLabel: '(in MT)',
      countColor: '#9747FF',
      countsSubLabel: 'Total quantity processed',
      icon: ironBarIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-[105px] -right-3.5 -top-4 w-28',
      onHoverContent: null,
    },
    {
      counts: `${Number(
        leaderShipToolAnalytics?.optimised_wastage || 0,
      ).toFixed(2)} %`,
      label: 'With/without bbs Optimization tool',
      subLabel: '( % )',
      countColor: '#12B76A',
      icon: valueChainIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      countsSubLabel: 'Total wastage',
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-[84px] right-1 -top-1 w-20',
      onHoverContent: null,
    },

    {
      counts: leaderShipToolAnalytics?.total_projects_with_bbs || 0,
      label: 'BBS Optimization usage',
      countsSubLabel: 'Projects with',
      countColor: '#FFFFFF',
      icon: checkIcon,
      bigText: true,
      bgColor: '#003B97',
      hasOuterLayer: true,
      outerLayerBg: '#99B1D5',
      labelColor: '#FFFFFF',
      countsSubLabelColor: '#ffffff7f',
      iconClasses: 'h-[105px] -right-3.5 -top-4 w-28',
    },
    {
      counts: Number(leaderShipToolAnalytics?.total_savings || 0).toFixed(1),
      label: 'SAVINGS WRT BUDGETED WASTAGE',
      countsSubLabel: 'Total in Rs Lakhs',
      countColor: '#DC6701',
      icon: coinsIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-[105px] -right-3 -top-3 w-28',
      onHoverContent: null,
    },
    {
      counts: `${Number(
        leaderShipToolAnalytics?.savings_wrt_budgeted_wastage || 0,
      ).toFixed(2)} %`,
      countsSubLabel: 'Percentage',
      label: 'SAVINGS WRT BUDGETED WASTAGE',
      countColor: '#FF8316',
      icon: garbageIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-[105px] -right-3.5 -top-4 w-28',
      onHoverContent: null,
    },
  ];

  const debouncedSearch = useCallback(
    debounce((query, results) => {
      dispatch(results({ search: query }));
    }, 500),
    [],
  );

  const handleSearch = (val, results) => {
    debouncedSearch(val, results);
  };

  const handleChange = (val, setVals, data, slug = '') => {
    if (slug === 'year') {
      setSelectedYear(val);
      return;
    }

    const allSelected = val.includes('all');
    const isSelectingAll = val.at(-1) === 'all';
    if (val.length === 0) {
      setVals([]);
      return;
    }

    if (slug === 'months') {
      const enabledMonths = data.filter((v) =>
        FINANCIAL_MONTHS.some((t) => v === t.complete && !t.disabled),
      );

      const isSelectingAll = val.includes('all') && val.at(-1) === 'all';
      const isDeselectingFromAll =
        val.includes('all') && val.length < enabledMonths.length + 1;

      if (val.length === 0) {
        setVals([]);
        return;
      }

      if (isSelectingAll) {
        setVals(['all', ...enabledMonths]);
      } else if (isDeselectingFromAll) {
        const newVals = val.filter((v) => v !== 'all');
        setVals(newVals);
      } else {
        setVals(val);
      }

      return;
    }

    if (isSelectingAll) {
      setVals(['all', ...data]);
    } else if (allSelected && val.length - 1 < data.length) {
      setVals(val.filter((v) => v !== 'all'));
    } else {
      setVals(val);
    }
  };

  return (
    <div className="relative z-20 flex w-full gap-3 pl-0 pr-4 md:pr-6 xl:pr-3 2xl:pl-3 2xl:pr-6 py-5 bg-[#F8F8F8] min-h-screen">
      <img
        src={viewerBgImg}
        alt="viewer bg img"
        className="fixed top-0 left-0 w-full -z-10"
      />

      <div className="w-full md:w-[70%] lg:w-[78%] relative flex flex-col mt-6 lg:mt-8 animate-moveFromTop">
        {/* excel sheet dpwnload button */}
        <Button
          disabled={!leadershipToolData.length}
          onClick={handleDownloadExcelSheet}
          className="font-['SF-Pro-Text-Regular, sans-serif'] hover:!bg-white hover:!text-[#1C4E9D] !bg-transparent -top-6  lg:-top-8 border border-white rounded-[4px] text-xs absolute right-0 !text-white"
        >
          Download
        </Button>

        <div className="mx-4 lg:mx-8">
          <div className="flex items-center gap-2">
            <h1 className="text-xl text-white font-segoe-ui">
              Metric Overview
            </h1>
            <Tooltip
              title={
                'Projects include System generated wastage BBS, Actual wastage BBS, Wastage without BBS - in the selected quarter'
              }
              overlayInnerStyle={{ fontSize: '10px' }}
            >
              <img
                className="w-3.5 h-3.5 cursor-pointer flex"
                src={dashboardCircle}
                alt="Info Icon"
              />
            </Tooltip>
          </div>
          {isInitialDataFetch && (
            <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-xs text-white opacity-70">
              Data from the Last Month
            </p>
          )}
        </div>

        {/* <Row className="flex justify-center w-full gap-3">
        <Button
          onClick={getAllInitialData}
          loading={leaderShipToolAnalyticsLoading || leadershipToolDataLoading}
          className="text-[#344054] font-medium text-sm h-9"
        >
          Reset Filters
        </Button>
        <Button
          loading={leaderShipToolAnalyticsLoading || leadershipToolDataLoading}
          onClick={handleApplyFilter}
          className="h-9 text-white font-medium bg-[#1C4E9D]"
        >
          Apply Filters
        </Button>
        <Button
          disabled={!leadershipToolData.length}
          onClick={handleDownloadExcelSheet}
          className="text-[#344054] font-medium text-sm h-9"
        >
          Download
        </Button>
      </Row> */}

        {/* cards */}
        <div className="justify-center w-full mt-5 mb-8 lg:flex ms-4 lg:ms-8 me-0 lg:me-5">
          <div className="flex flex-col gap-2.5 lg:w-[78%]">
            <div className="grid grid-cols-3 gap-2.5 w-full">
              {COUNTS.map((count) => {
                return (
                  <MetricsCard
                    key={count.countColor}
                    data={count}
                    loading={leaderShipToolAnalyticsLoading}
                  />
                );
              })}
            </div>
          </div>
        </div>

        <div className="px-2 py-2 ml-3 bg-white lg:px-5 rounded-xl">
          <div className="flex items-center gap-2">
            <h1 className="text-xl font-segoe-ui text-[#1C4E9D]">Data</h1>
            <Tooltip
              title={
                'Quantity processed and waste for projects with optimized BBS'
              }
              overlayInnerStyle={{ fontSize: '10px' }}
            >
              <img
                className="w-3.5 h-3.5 cursor-pointer flex"
                src={dashboardCircle}
                alt="Info Icon"
              />
            </Tooltip>
          </div>

          <WastageProjectInfoMonthly
            loading={leadershipToolDataLoading}
            dataSource={leadershipToolData}
          />
        </div>
      </div>

      {/* right section */}
      <AdvanceFilter
        loadingData={
          leaderShipToolAnalyticsLoading || leadershipToolDataLoading
        }
        resetFilter={getAllInitialData}
        applyFilter={handleApplyFilter}
        filterForm={
          <DashboardFilterSelectorsMonthly
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            years={YEARS}
            selectedMonths={selectedMonths}
            FINANCIAL_MONTHS={FINANCIAL_MONTHS}
            setSelectedMonths={setSelectedMonths}
            handleSearch={handleSearch}
            handleChange={handleChange}
            sbgListLoading={sbgListLoading}
            selectedSBG={selectedSBG}
            sbgListData={sbgListData}
            setSelectedSBG={setSelectedSBG}
            sbuListLoading={sbuListLoading}
            getSBUList={getSBUList_TA}
            selectedSBU={selectedSBU}
            sbuListData={sbuListData}
            setSelectedSBU={setSelectedSBU}
            buListLoading={buListLoading}
            selectedBU={selectedBU}
            getBUList={getBUList_TA}
            buListData={buListData}
            setSelectedBU={setSelectedBU}
            projectListLoading={projectListLoading}
            selectedProjectsCode={selectedProjectsCode}
            projectListData={projectListData}
            setSelectedProjectsCode={setSelectedProjectsCode}
            selectedProjectsName={selectedProjectsName}
            getProjectList={getProjectList_TA}
            loadProjectNames={loadProjectNames}
            setSelectedProjectsName={setSelectedProjectsName}
          />
        }
      />
    </div>
  );
};

export default ToolAdherence;
